import React, { useEffect, useState } from "react";
import { Table, Spin, Empty, Pagination } from "antd";
import Select from "react-select";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { fetchAllEmployees } from "../../../store/slices/EmployeeSlice";
import {
  fetchAllTasks,
  createTask,
  deleteTask,
  updateTask,
} from "../../../store/slices/TaskSlice";
// ../../../store/slices/TaskSlice
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import AddTaskModalPopup from "../../../components/modelpopup/AddTaskModalPopup";
import { handleError } from "../../../hooks/utils/assetsHelper";
import useFetch from "../../../hooks/api/fetchHook";
import TaskDetailsModalPopup from "../../../components/modelpopup/TaskDetailModalPopup";

const Task = () => {
  const dispatch = useDispatch();
  const { userToken } = useSelector((state) => state?.auth);
  const { tasks, total, loading, error } = useSelector((state) => state.tasks);
  const [selectedTask, setSelectedTask] = useState(false);
  const [selectedTaskData, setSelectedTaskData] = useState(null);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isTaskDetailsModalVisible, setIsTaskDetailsModalVisible] =
    useState(false);
  const [selectedTaskForDetails, setSelectedTaskForDetails] = useState(null);
  const [searchAssignedTo, setSearchAssignedTo] = useState("");
  const [searchAssignedBy, setSearchAssignedBy] = useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(10);
  const [filters, setFilters] = React.useState({
    status: "All",
    priority: "All",
    assignedTo: "All",
    assignedBy: "All",
  });
  const [sortParams, setSortParams] = React.useState({
    field: null,
    order: null,
  });
  const [mode, setMode] = useState();

  useEffect(() => {
    const filterObj = {};
    if (filters.status !== "All") filterObj.status = filters.status;
    if (filters.priority !== "All") filterObj.priority = filters.priority;
    if (filters.assignedTo !== "All") filterObj.assignedTo = filters.assignedTo;
    if (filters.assignedBy !== "All") filterObj.assignedBy = filters.assignedBy;

    dispatch(
      fetchAllTasks({
        page: currentPage,
        limit: pageSize,
        filter: filterObj,
      })
    )
      .unwrap()
      .catch((err) => {
        toast.error("Failed to load tasks: " + err);
      });
  }, [dispatch, currentPage, pageSize, filters, sortParams]);

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${userToken}`,
    },
  };

  const {
    apiData: departmentsData,
    isLoading: departmentsLoading,
    isError: departmentsError,
  } = useFetch(
    `${process.env.REACT_APP_BASE_URL}/api/departments`,
    options
  );

  // Find development department ID if it exists
  const [departmentId, setDepartmentId] = useState(null);

  useEffect(() => {
    if (!departmentsLoading && !departmentsError && departmentsData) {
      const departments = departmentsData?.data?.departments || [];
      const developmentDept = departments.find((dept) => dept.type === "development");
      if (developmentDept) {
        setDepartmentId(developmentDept._id);
      }
    }
  }, [departmentsLoading, departmentsError, departmentsData]);

  // Fetch users based on department
  const {
    apiData,
    isLoading: fetchLoading,
    isError: fetchError,
  } = useFetch(`${process.env.REACT_APP_BASE_URL}/api/users?department=${departmentId}`,
    options
  );

  useEffect(() => {
    if (fetchLoading) {
      setIsLoading(true);
    } else if (fetchError) {
      setIsError(true);
      setIsLoading(false);
    } else if (apiData) {
      setUsers(apiData.data.users || []);
      setIsLoading(false);
    }
  }, [fetchLoading, fetchError, apiData]);

  const buttonStyles = {
    display: "flex",
    alignItems: "center",
    padding: "8px 12px",
    fontSize: "16px",
    color: "#007bff",
    backgroundColor: "#f8f9fa",
    border: "2px solid #007bff",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "all 0.3s ease",
  };

  const hoverStyles = {
    backgroundColor: "#007bff",
    color: "#fff",
  };

  const handleMouseEnter = (e) => {
    Object.assign(e.currentTarget.style, hoverStyles);
  };

  const handleMouseLeave = (e) => {
    Object.assign(e.currentTarget.style, buttonStyles);
  };

  useEffect(() => {
    dispatch(fetchAllEmployees({}));
  }, [dispatch]);

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
    setCurrentPage(1);
  };

  const handleReload = () => {
    dispatch(
      fetchAllTasks({
        page: currentPage,
        limit: pageSize,
        filter: filters.status !== "All" ? { status: filters.status } : {},
      })
    );
  };

  const handleAddTask = async (taskData) => {
    try {
      const resultAction = await dispatch(createTask(taskData));

      if (resultAction.error) {
        const errorMessage = resultAction?.payload || "Failed to add task";
        toast.error("Error: " + errorMessage);
      } else {
        toast.success("Task Added Successfully!");
        handleReload();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to add task";
      toast.error("Error: " + errorMessage);
    }
  };

  const handleUpdateTask = async (taskData) => {
    try {
      await dispatch(
        updateTask({ id: selectedTaskData._id, taskData })
      ).unwrap();
      toast.success("Task updated successfully");
      resetSelection();
      handleReload();
    } catch (error) {
      handleError(error, "Failed to update task");
    }
  };

  const handleEditTask = (task) => {
    setSelectedTaskData(task);
    setMode("edit");
  };

  const handleDeleteTask = (task) => {
    setSelectedTask(task);
  };

  const handleDelete = () => {
    if (selectedTask) {
      dispatch(deleteTask(selectedTask._id));
      toast.success("Task Deleted Successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        theme: "colored",
      });
      setTimeout(() => {
        handleReload();
      }, 1000);
    }
  };

  const handleTaskClick = (task) => {
    setSelectedTaskForDetails(task);
    setIsTaskDetailsModalVisible(true);
  };

  const handleTaskDetailsModalClose = () => {
    setIsTaskDetailsModalVisible(false);
    setSelectedTaskForDetails(null);
  };

  const resetSelection = () => {
    setSelectedTaskData(null);
    setMode(null);
  };

  const statusOptions = [
    { value: "All", label: "All Tasks" },
    { value: "to-do", label: "To do" },
    { value: "in-progress", label: "In Progress" },
    { value: "completed", label: "Completed" },
    { value: "cancelled", label: "Cancelled" },
  ];

  const statusOptionsInline = [
    { value: "to-do", label: "To do" },
    { value: "in-progress", label: "In Progress" },
    { value: "completed", label: "Completed" },
    { value: "cancelled", label: "Cancelled" },
  ];

  const priorityOptions = [
    { value: "All", label: "All Priorities" },
    { value: "low", label: "Low" },
    { value: "medium", label: "Medium" },
    { value: "high", label: "High" },
  ];

  const priorityOptionsInline = [
    { value: "low", label: "Low" },
    { value: "medium", label: "Medium" },
    { value: "high", label: "High" },
  ];

  const statusColorMap = {
    "To do": "text-info",
    "In Progress": "text-warning",
    Completed: "text-success",
    Cancelled: "text-danger",
  };

  const priorityColorMap = {
    Low: "text-success",
    Medium: "text-warning",
    High: "text-danger",
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 100,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => (
        <div
          style={{
            width: 160,
            maxWidth: 350,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={text}
        >
          {text || "No description"}
        </div>
      ),
    },
    {
      title: "Assigned To",
      key: "assignedTo",
      render: (_, record) => {
        const assignedToList = Array.isArray(record.assignedTo)
          ? record.assignedTo
          : [];
        const assignedToIds = assignedToList.map((user) => user._id);

        const firstUser = assignedToList[0];
        const isMultiple = assignedToList.length > 1;
        const displayName = firstUser
          ? `${firstUser.firstName || ""} ${firstUser.lastName || ""}`.trim()
          : "Unassigned";

        const handleAddUser = (user) => {
          if (!assignedToIds.includes(user._id)) {
            const updatedAssignedTo = [...assignedToIds, user._id];
            dispatch(
              updateTask({
                id: record._id,
                taskData: { assignedTo: updatedAssignedTo },
              })
            )
              .unwrap()
              .then(() => toast.success("User added to Assigned To."))
              .catch((err) => toast.error("Failed: " + (err?.message || err)))
              .finally(() => handleReload());
          }
        };

        const handleRemoveUser = (userId) => {
          const updatedAssignedTo = assignedToIds.filter((id) => id !== userId);
          dispatch(
            updateTask({
              id: record._id,
              taskData: { assignedTo: updatedAssignedTo },
            })
          )
            .unwrap()
            .then(() => toast.success("User removed from Assigned To."))
            .catch((err) => toast.error("Failed: " + (err?.message || err)))
            .finally(() => handleReload());
        };

        return (
          <div
            onClick={(e) => e.stopPropagation()}
            className="dropdown action-label text-start"
          >
            <div
              className="btn btn-white btn-sm btn-rounded dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="far fa-dot-circle text-info" /> {displayName}
              {isMultiple && " ..."}
            </div>

            <div
              className="dropdown-menu dropdown-menu-right p-2"
              style={{
                maxHeight: "280px",
                overflowY: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                minWidth: "160px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#fff",
                  zIndex: 1,
                }}
              >
                <input
                  type="text"
                  placeholder="Search user..."
                  className="form-control mb-2"
                  value={searchAssignedTo}
                  onChange={(e) => setSearchAssignedTo(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                />
              </div>

              <div
                style={{ maxHeight: "150px", overflowY: "auto" }}
                className="d-flex flex-column gap-1"
              >
                {users
                  .filter((user) =>
                    `${user.firstName} ${user.lastName}`
                      .toLowerCase()
                      .includes(searchAssignedTo.toLowerCase())
                  )
                  .map((user) => {
                    const isSelected = assignedToIds.includes(user._id);
                    return (
                      <div
                        key={user._id}
                        className="dropdown-item d-flex justify-content-between align-items-center"
                        style={{
                          cursor: "pointer",
                          backgroundColor: isSelected
                            ? "#d0ebff"
                            : "transparent",
                          borderRadius: "4px",
                          paddingLeft: "8px",
                          paddingRight: "8px",
                        }}
                        onClick={() =>
                          isSelected
                            ? handleRemoveUser(user._id)
                            : handleAddUser(user)
                        }
                      >
                        <span>
                          <i className="far fa-dot-circle text-success" />{" "}
                          {user.firstName} {user.lastName}
                        </span>
                        {isSelected && (
                          <span
                            style={{
                              color: "red",
                              fontWeight: "bold",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveUser(user._id);
                            }}
                          >
                            ×
                          </span>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Assigned By",
      key: "assignedBy",
      render: (_, record) => {
        const filteredUsers = users.filter((user) =>
          `${user.firstName} ${user.lastName}`
            .toLowerCase()
            .includes(searchAssignedBy.toLowerCase())
        );

        return (
          <div
            onClick={(e) => e.stopPropagation()}
            className="dropdown action-label text-start"
          >
            <div
              className="btn btn-white btn-sm btn-rounded dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="far fa-dot-circle text-info" />{" "}
              {record.assignedBy?.firstName} {record.assignedBy?.lastName}
            </div>
            <div
              className="dropdown-menu dropdown-menu-right p-2"
              style={{
                maxHeight: "280px",
                overflowY: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                minWidth: "120px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#fff",
                  zIndex: 1,
                }}
              >
                <input
                  type="text"
                  placeholder="Search user..."
                  className="form-control mb-2"
                  value={searchAssignedBy}
                  onChange={(e) => setSearchAssignedBy(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                />
              </div>

              <div
                style={{
                  maxHeight: "150px",
                  overflowY: "auto",
                }}
              >
                {filteredUsers.map((user) => (
                  <div
                    key={user._id}
                    className="dropdown-item"
                    style={{
                      cursor: "pointer",
                      paddingLeft: "8px",
                      paddingRight: "8px",
                    }}
                    onClick={() =>
                      dispatch(
                        updateTask({
                          id: record._id,
                          taskData: { assignedBy: user._id },
                        })
                      )
                        .unwrap()
                        .then(() => toast.success("Assigned By updated."))
                        .catch((err) =>
                          toast.error("Update failed: " + (err?.message || err))
                        )
                        .finally(() => handleReload())
                    }
                  >
                    <i className="far fa-dot-circle text-success cursor-pointer" />{" "}
                    {user.firstName} {user.lastName}
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Status",
      key: "status",
      render: (_, record) => (
        <div
          onClick={(e) => e.stopPropagation()}
          className="dropdown action-label text-start"
        >
          <div
            className="btn btn-white btn-sm btn-rounded dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i
              className={`far fa-dot-circle ${
                record.status === "to-do"
                  ? "text-info"
                  : record.status === "in-progress"
                  ? "text-warning"
                  : record.status === "completed"
                  ? "text-success"
                  : record.status === "cancelled"
                  ? "text-danger"
                  : ""
              }`}
            />{" "}
            {record.status}
          </div>
          <div className="dropdown-menu dropdown-menu-right">
            {statusOptionsInline.map((option) => (
              <div
                key={option.value}
                className="dropdown-item"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  dispatch(
                    updateTask({
                      id: record._id,
                      taskData: { status: option.value },
                    })
                  )
                    .unwrap()
                    .then(() => toast.success("Status updated."))
                    .catch((err) =>
                      toast.error("Update failed: " + (err?.message || err))
                    )
                    .finally(() => handleReload())
                }
              >
                <i
                  className={`far fa-dot-circle ${
                    statusColorMap[option.label] || ""
                  } cursor-pointer`}
                />{" "}
                {option.label}
              </div>
            ))}
          </div>
        </div>
      ),
    },
    {
      title: "Priority",
      key: "priority",
      render: (_, record) => (
        <div
          onClick={(e) => e.stopPropagation()}
          className="dropdown action-label text-start"
        >
          <div
            className="btn btn-white btn-sm btn-rounded dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i
              className={`far fa-dot-circle ${
                record.priority === "low"
                  ? "text-success"
                  : record.priority === "medium"
                  ? "text-warning"
                  : record.priority === "high"
                  ? "text-danger"
                  : ""
              }`}
            />{" "}
            {record.priority}
          </div>
          <div className="dropdown-menu dropdown-menu-right">
            {priorityOptionsInline.map((option) => (
              <div
                key={option.value}
                className="dropdown-item"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  dispatch(
                    updateTask({
                      id: record._id,
                      taskData: { priority: option.value },
                    })
                  )
                    .unwrap()
                    .then(() => toast.success("Priority updated."))
                    .catch((err) =>
                      toast.error("Update failed: " + (err?.message || err))
                    )
                    .finally(() => handleReload())
                }
              >
                <i
                  className={`far fa-dot-circle ${
                    priorityColorMap[option.label] || ""
                  } cursor-pointer`}
                />{" "}
                {option.label}
              </div>
            ))}
          </div>
        </div>
      ),
    },
    {
      title: "Due Date",
      dataIndex: "dueDate",
      key: "dueDate",
      render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
    },
    {
      title: "Action",
      className: "text-end",
      render: (_, record) => (
        <div
          className="dropdown dropdown-action text-end"
          onClick={(e) => e.stopPropagation()}
        >
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              data-bs-toggle="modal"
              data-bs-target="#edit_task"
              onClick={(e) => {
                e.stopPropagation();
                handleEditTask(record);
              }}
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            <Link
              className="dropdown-item"
              data-bs-toggle="modal"
              data-bs-target="#delete"
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteTask(record);
              }}
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </Link>
          </div>
        </div>
      ),
      width: "10%",
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Breadcrumbs
          maintitle="Tasks"
          title="Dashboard"
          subtitle="Tasks"
          name="Add Task"
          modal="#edit_task"
          modalClass="col-auto float-end ms-auto"
        />

        {/* Filters */}
        <div className="row mb-3 gap-md-0 gap-3 d-flex justify-content-between">
          <div className="col-md-12 d-flex align-items-center justify-content-end mb-0 mb-md-3">
            <button
              onClick={handleReload}
              className="reload-button"
              style={buttonStyles}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <i className="la la-sync"></i>
            </button>
          </div>

          <div className="col-md-3 col-12">
            <Select
              options={statusOptions}
              value={statusOptions.find((o) => o.value === filters.status)}
              onChange={(opt) => handleFilterChange("status", opt.value)}
              placeholder="Filter by Status"
            />
          </div>

          <div className="col-md-3 col-12">
            <Select
              options={priorityOptions}
              value={priorityOptions.find((o) => o.value === filters.priority)}
              onChange={(opt) => handleFilterChange("priority", opt.value)}
              placeholder="Filter by Priority"
            />
          </div>

          <div className="col-md-3 col-12">
            <Select
              options={[
                { value: "All", label: "Select Assigned To" },
                ...users.map((user) => ({
                  label: `${user.firstName} ${user.lastName}`,
                  value: user._id,
                })),
              ]}
              value={
                filters.assignedTo === "All"
                  ? { value: "All", label: "Select Assigned To" }
                  : users
                      .map((user) => ({
                        value: user._id,
                        label: `${user.firstName} ${user.lastName}`,
                      }))
                      .find((o) => o.value === filters.assignedTo) || null
              }
              onChange={(opt) => handleFilterChange("assignedTo", opt.value)}
              isLoading={isLoading}
              noOptionsMessage={() =>
                isError ? "Error loading users" : "No users found"
              }
              placeholder="Filter by Assigned To"
            />
          </div>

          <div className="col-md-3 col-12">
            <Select
              options={[
                { value: "All", label: "Select Assigned By" },
                ...users.map((user) => ({
                  label: `${user.firstName} ${user.lastName}`,
                  value: user._id,
                })),
              ]}
              value={
                filters.assignedBy === "All"
                  ? { value: "All", label: "Select Assigned By" }
                  : users
                      .map((user) => ({
                        value: user._id,
                        label: `${user.firstName} ${user.lastName}`,
                      }))
                      .find((o) => o.value === filters.assignedBy) || null
              }
              onChange={(opt) => handleFilterChange("assignedBy", opt.value)}
              isLoading={isLoading}
              noOptionsMessage={() =>
                isError ? "Error loading users" : "No users found"
              }
              placeholder="Filter by Assigned By"
            />
          </div>
        </div>

        {/* Table */}
        <Spin spinning={loading}>
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive mb-3">
                <div>
                  <Table
                    columns={columns}
                    dataSource={tasks}
                    className="table-striped"
                    style={{ cursor: "pointer" }}
                    rowKey={(record) => record._id || record.id}
                    pagination={false}
                    onRow={(record) => ({
                      onClick: () => handleTaskClick(record),
                    })}
                    locale={{
                      emptyText: "No Task.",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Spin>
        <div
          className="mt-4"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={total}
            onChange={handlePageChange}
            showSizeChanger
            pageSizeOptions={["10", "25", "50", "100"]}
            showQuickJumper
            showTotal={(total) => `Total ${total} tasks`}
            itemRender={(page, type, originalElement) => {
              if (type === "prev") {
                return <span>Previous</span>;
              }
              if (type === "next") {
                return <span>Next</span>;
              }
              return originalElement;
            }}
          />
        </div>
      </div>
      <AddTaskModalPopup
        onSubmit={handleAddTask}
        onEdit={handleUpdateTask}
        editTask={selectedTaskData}
        setSelectedTaskData={setSelectedTaskData}
        mode={mode}
        setMode={setMode}
      />
      <TaskDetailsModalPopup
        visible={isTaskDetailsModalVisible}
        task={selectedTaskForDetails}
        onClose={handleTaskDetailsModalClose}
      />
      <DeleteModal Name="Delete Task" onDeleteLeave={handleDelete} />
    </div>
  );
};

export default Task;